export default "__VITE_ASSET__IANUFlGx__"